import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_ZONE',
  GET: 'GET_ZONE',
  CREATE: 'CREATE_ZONE',
  EDIT: 'EDIT_ZONE',
  DELETE: 'DELETE_ZONE',
  DUPLICATE: 'DUPLICATE_ZONE',
  ADD_ZONE_TO_FLOOR: 'ADD_ZONE_TO_FLOOR',
  REMOVE_ZONE_FROM_FLOOR: 'REMOVE_ZONE_FROM_FLOOR',
  CLEAR_ERROR: 'CLEAR_ERROR_ZONE',
};

export const clearErrorZone = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchZoneByText = (text, buildingId, page = 0, floorId = undefined) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = null;
  const filtered = text;
  const isPublic = null;
  return searchZone(pageSize, page, sorted, filtered, isPublic, buildingId, floorId);
};

export const searchZone = (pageSize, page, sorted, filtered, isPublic, buildingId, floorId = undefined) => {
  let floorParams = { building_id: buildingId };
  if (floorId !== undefined) {
    floorParams = {
      ...floorParams,
      ...(floorId === null ? { floor_id__isnull: true } : { floor_id: floorId })
    };
  }

  return RestClient.request({
    method: 'get',
    url: Constants.API_ZONE,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id).join(',')
        : null,
      is_public: isPublic,
      ...floorParams,
    },
  });
};

export const listZone = (pageSize, page, sorted, filtered, isPublic, buildingId, floorId) => {
  return {
    type: ACTION.LIST,
    payload: searchZone(pageSize, page, sorted, filtered, isPublic, buildingId, floorId),
  };
};

export const getZone = zoneId => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_ZONE}${zoneId}/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const duplicateZone = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_ZONE}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteZone = (zoneId, params) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_ZONE}${zoneId}/`,
      data: params,
    })
      .then(() => ({ id: zoneId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const editZone = (id, name, area, floorId, description) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (area) formData.set('area', area);
  formData.set('floor_id', floorId === null ? '' : floorId);
  if (typeof description === 'string') formData.set('description', description);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_ZONE}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createZone = (name, area, floorId, description, buildingId) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('area', area);
  formData.set('floor_id', floorId === null ? '' : floorId);
  if (typeof description === 'string') formData.set('description', description);
  formData.set('building_id', buildingId);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_ZONE,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const addZoneToFloor = (id, floorId) => {
  const formData = new FormData();
  formData.set('floor_id', floorId);

  return {
    type: ACTION.ADD_ZONE_TO_FLOOR,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_ZONE}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeZoneFromFloor = id => {
  const formData = new FormData();
  formData.set('floor_id', '');

  return {
    type: ACTION.REMOVE_ZONE_FROM_FLOOR,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_ZONE}${id}/`,
      data: formData,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/zone/zone_actions.js